import React, { Component } from 'react'
import get from 'lodash/get'
import VideoShare from './components/index'
import { fetchSharedVideoInfo } from './actions/queries'
import BuriedPoint from '../../utils/log'
import { getVisitorId } from './visitorId'

/**
 * 视频分享落地页的数据层(TAPD 1006913)
 *
 * 三段式与 knowledgeShare 一致(index 取数 + components 渲染 + actions 取数定义),
 * 区别是这里**不用 graphql() HOC** —— 全局 ApolloClient 指向 blog-backend,
 * 而本页数据在 pigeon,所以自己 axios(见 actions/queries.js 顶部注释)。
 */
export default class VideoShareContainer extends Component {
  state = {
    loading: true,
    data: null,
    message: '',
    // 失效原因(NOT_FOUND / OFFLINE / SHARE_DISABLED / NO_VIDEO_SOURCE / NETWORK)。
    // 业务上的四种共用同一句文案,但 NETWORK 得区分开 —— 网络抖一下就说"视频已下架",
    // 用户会以为内容被删了。
    reason: '',
  }

  componentDidMount() {
    const videoId = get(this.props, 'match.params.videoId', '')

    // PV **进页即报**,不等取数返回 —— 评论区埋点规范的原话就是"进页即报",而 videoId
    // 从 URL 就拿得到,压根不需要等数据。挂在取数回调里的话:弱网下 pigeon 要几秒
    // (axios timeout 15s),用户看不到东西直接退出,这次访问就既没 PV 也没 UV ——
    // 而偏差正好集中在弱网人群,会让"分享带回多少人"这个指标系统性偏小。
    //
    // 事件名按 TAPD 1006913 评论区的埋点规范,也正好与本仓既有落地页
    // PAGE_INIT_KNOWLEDGE_SHARE 同一个模式(knowledgeShare/components/index.js)。
    // available 拆到下面 _RESULT 那条去报:它得等数据,PV 不该被它拖着。
    BuriedPoint.saLog('PAGE_INIT_VIDEO_SHARE', {
      id: getVisitorId(),
      payload: { videoId, visitorId: getVisitorId() },
    })

    fetchSharedVideoInfo(videoId).then(res => {
      const data = res && res.success ? res.data : null
      this.setState({ loading: false, data, message: get(res, 'message', ''), reason: get(res, 'reason', '') })

      // 标题必须等数据到手才设:组件挂载那一刻还在 loading、data 是 null,
      // 放在上面会导致微信导航栏永远显示 index.html 的默认标题。
      const title = get(data, 'title')
      if (title) document.title = title

      // 能不能看,单独一条(PV 已在进页时报过,这里只补结果维度)
      BuriedPoint.saLog('VIDEO_SHARE_LOAD_RESULT', {
        id: getVisitorId(),
        payload: { videoId, visitorId: getVisitorId(), available: !!data, reason: get(res, 'reason', '') },
      })
    })
  }

  render() {
    const videoId = get(this.props, 'match.params.videoId', '')
    return (
      <VideoShare
        videoId={videoId}
        loading={this.state.loading}
        data={this.state.data}
        message={this.state.message}
        reason={this.state.reason}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/videoShare/index.js